import React from 'react';
import { IMapPoint } from '../../../models/interfaces/IMapPoint';

import Waypoint from './Waypoint';
import { WaypointsContainer } from './waypointStyles';
import { SectionTitle } from '../../Global/styles';

type WaypointsProps = {
	points: IMapPoint[];
};

const Waypoints: React.FC<WaypointsProps> = ({ points }) => {
	const waypoints = points.filter((point) => {
		return point.is_poi;
	});

	return (
		<WaypointsContainer>
			<SectionTitle>Waypoints</SectionTitle>
			<>
				{waypoints.map((waypoint, i) => {
					return (
						<Waypoint
							key={`${waypoint.lat}-${waypoint.lng}-${i}`}
							waypoint={waypoint}
							i={i}
						/>
					);
				})}
			</>
		</WaypointsContainer>
	);
};

export default Waypoints;
